import { createContext } from 'react'
import { LucideIcon } from 'lucide-react'

export interface PageHistoryItem {
  id: string
  path: string
  title: string
  icon?: LucideIcon
  timestamp: number
}

export interface HistoryContextType {
  history: PageHistoryItem[]
  addToHistory: (path: string, title?: string) => void
  clearHistory: () => void
  removeFromHistory: (id: string) => void
}

export const HistoryContext = createContext<HistoryContextType | undefined>(undefined)
